import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    useNotificationStore,
    useAdobeTarget,
} from '../hooks/store';
import { useMediaConfig } from '../hooks/config';

import Component from '../components/Notification';

const Notification = ({
    id,
    contentConfig,
    ...otherProps
}) => {

    const {
        shouldShowNotification,
        dismissNotification,
    } = useNotificationStore(id);
    const { adobeTarget: adobeTargetConfig = {} } = useMediaConfig();
    const adobeTargetTestKey = contentConfig.adobeTargetTestKey;
    const {
        loading,
        payload = false,
        enabled,
    } = useAdobeTarget(adobeTargetConfig, adobeTargetTestKey);

    const onDismiss = useCallback(()=> {

        dismissNotification(id);

    }, [
        dismissNotification,
        id,
    ]);

    return (
        shouldShowNotification
        && (
            !adobeTargetTestKey
            || (
                enabled
                && !loading
                && payload
            )
        )
        && <Component
            onDismiss={onDismiss}
            contentConfig={contentConfig}
            {...otherProps}
        />
    );

};

Notification.propTypes = {
    id: PropTypes.string.isRequired,
    contentConfig: PropTypes.object.isRequired,
};

export default Notification;
